module.exports = __webpack_public_path__ + "ptc_momoro_K2.effd3abd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_K2.jpg
// module id = qiS/
// module chunks = 0